import { createReducer } from 'store/createReducer';
import { HEADER_STORES_CLOSE, HEADER_STORES_OPEN } from './actions';

export const initialState = {
  url: '',
  visible: false,
  isOpen: false,
  header: '',
  subHeader: '',
  stores: []
};

export default createReducer(initialState, {
  [HEADER_STORES_OPEN]: state => {
    return { ...state, isOpen: true };
  },
  [HEADER_STORES_CLOSE]: state => {
    return { ...state, isOpen: false };
  }
});
